import Crypto from "crypto-js";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
// https://github.com/brix/crypto-js
/**
 * rsa加密公钥
 * @type {string}
 */
const rsaPublicKey =
  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCWxukn6ppx3nXhqDG9GdvGoaGa9NUTO7tXDa6JMoQnqUMAjfSCk1Qzc0/IkTjfmJ9yN29JVkX1YogcXWHxbXP7LLR5Iv2A2+wiHj7VWcUwtC04Tehs1fIDBoacGn85Dg1nIaB3rdp18xF9l1V/R+qE79wOCDEHDvduA02vPDF0BQIDAQAB";

let random = randomString();
/**
 * 请求头stochastic
 * @type {*}
 */
export const stochastic = encryptRSA(random);
/**
 * Aes加解密的key
 */
let key = Crypto.enc.Utf8.parse(random);

/**
 * 加密
 * @param str
 * @returns {string}
 */
export function encrypt(str) {
  let encryptStr = Crypto.AES.encrypt(str, key, {
    mode: Crypto.mode.ECB,
    padding: Crypto.pad.Pkcs7,
  });
  return encryptStr.ciphertext.toString(Crypto.enc.Base64);
}

/**
 * 解密
 * @param str
 * @returns {*}
 */
export function decrypt(str) {
  let decrypt = Crypto.AES.decrypt(str, key, {
    mode: Crypto.mode.ECB,
    padding: Crypto.pad.Pkcs7,
  });
  return Crypto.enc.Utf8.stringify(decrypt).toString();
}

/**
 * 非对称加密
 * @param str
 * @returns {*}
 */
export function encryptRSA(str) {
  const encryptObj = new JSEncrypt();
  encryptObj.setPublicKey(rsaPublicKey);
  return encryptObj.encrypt(str);
}

/**
 * 随机16位字符串
 * @returns {string}
 */
function randomString() {
  const len = 16;
  const $chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let maxPos = $chars.length;
  let pwd = "";
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}
